module.exports = __webpack_public_path__ + "static/media/dark_logo.6cfb92c1.png";